import { render, staticRenderFns } from "./PackagesTable.vue?vue&type=template&id=28748509"
import script from "./PackagesTable.vue?vue&type=script&lang=js"
export * from "./PackagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports